module.exports = __webpack_public_path__ + "img/purple-square-table-2.206856f1.png";